var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBird4 = function SvgBird4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "50 0 286 286"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m180 142.5 37.5-22.5H120l-37.5 90 37.5 16.7V285h7.5v-55l22.5 10 22.5-10v55h7.5v-58.3l37.5-16.7zm-37.5 7.5c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5"
  })));
};
export default SvgBird4;